export default "__VITE_ASSET__co2TTltT__"